/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseApiClient } from '../base-api-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CommonSettings } from '../models/common-settings';

@Injectable({ providedIn: 'root' })
export class CommonSettingsApiClient extends BaseApiClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCommonSettings()` */
  static readonly GetCommonSettingsPath = '/api/v1/commonsettings';

  /**
   * Get common settings.
   *
   * Get common settings
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCommonSettings$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCommonSettings$Plain$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<CommonSettings>> {
    const rb = new RequestBuilder(this.rootUrl, CommonSettingsApiClient.GetCommonSettingsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CommonSettings>;
      })
    );
  }

  /**
   * Get common settings.
   *
   * Get common settings
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCommonSettings$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCommonSettings$Plain(
    params?: {
    },
    context?: HttpContext
  ): Observable<CommonSettings> {
    return this.getCommonSettings$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CommonSettings>): CommonSettings => r.body)
    );
  }

  /**
   * Get common settings.
   *
   * Get common settings
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCommonSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCommonSettings$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<CommonSettings>> {
    const rb = new RequestBuilder(this.rootUrl, CommonSettingsApiClient.GetCommonSettingsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CommonSettings>;
      })
    );
  }

  /**
   * Get common settings.
   *
   * Get common settings
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCommonSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCommonSettings(
    params?: {
    },
    context?: HttpContext
  ): Observable<CommonSettings> {
    return this.getCommonSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<CommonSettings>): CommonSettings => r.body)
    );
  }

}
